import React, {Component} from 'react';

export default class Input extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <input type="text" id={this.props.type} name={this.props.type}
               className="search-component__input"
               value={this.props.inputValue}
               placeholder={this.props.placeholder}
               onFocus={() => this.props.handleFocus("focus")}
               onBlur={() => this.props.handleFocus("blur")}
               onChange={this.props.handleInput} />
        )
    }
}
